import {Ability} from '~/lib/ability';

export class DashboardAbility extends Ability {
    canViewBySeller = () => this.isAdmin();
    canViewByAgency = () => this.isManager() || this.isAdmin();
    canViewByPayer = () => this.isSeller() || this.isSelfServe() || this.isAdmin();
    canViewAdRequests = () => this.isManager() || this.isAdmin() || this.enabledFeature('UI_SHOW_AD_REQUESTS_COLUMN');
}
